<template>
  <section>
    <CommonAccordion
      v-for="(requisite,index) in value"
      :key="index"
      class="rounded-5 mb-2"
      style="background-color:#FCFCFC"
      :accordionTitle1="true"
    >
      <template #header>
        <div class="d-flex w-100 p-3">
          <span class="flex-1 text-left">{{ requisite.name || 'Untitled Requirement' }}</span>
          <span>
            <AppBadge v-if="requisite.showInCatalog">Shown in catalog</AppBadge>
          </span>
        </div>
      </template>
      <template #content>
        <section
          class="p-3"
          :data-test="`advancedRequisiteContent${index}`"
        >
          <AdvanceRequisite
            :level="1"
            :disabled="true"
            :editing="false"
            :value="requisite"
          />
        </section>
      </template>
    </CommonAccordion>
  </section>
</template>

<script>
import AdvanceRequisite from './AdvanceRequisite'
import CommonAccordion from '@/components/Common/CommonAccordion'

export default {
  components: {
    AdvanceRequisite,
    CommonAccordion,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
}
</script>
